import { render, staticRenderFns } from "./UploadTab.vue?vue&type=template&id=5dabfaee&scoped=true"
import script from "./UploadTab.vue?vue&type=script&lang=js"
export * from "./UploadTab.vue?vue&type=script&lang=js"
import style0 from "./UploadTab.vue?vue&type=style&index=0&id=5dabfaee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dabfaee",
  null
  
)

export default component.exports